import validator from "validator";

export function forgotPasswordValidator(values) {
  const errors: any = {};
  if (!values.email) {
    errors.email = "Email field is required";
  } else if (!validator.isEmail(values.email)) {
    errors.email = "Email must be a valid email address";
  }

  return errors;
}
